import React, { useEffect, useState } from "react";

function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function UploadTile({ label, preview, onChange, aspectClass, inputId }) {
  return (
    <label
      className={[
        "new-merchant-information__upload-tile",
        aspectClass,
        preview ? "has-preview" : "",
      ].filter(Boolean).join(" ")}
      htmlFor={inputId}
      style={preview ? { backgroundImage: `url(${preview})` } : undefined}
    >
      <input
        id={inputId}
        type="file"
        accept="image/*"
        onChange={onChange}
      />
      {!preview ? (
        <span className="new-merchant-information__upload-placeholder">
          <strong>{label}</strong>
          <small>Choose an image</small>
        </span>
      ) : (
        <span className="new-merchant-information__upload-overlay">{label}</span>
      )}
    </label>
  );
}

export default function ImagePicker({
  logoPreview = "",
  coverPreview = "",
  onLogoChange,
  onCoverChange,
}) {
  const [localLogoPreview, setLocalLogoPreview] = useState(logoPreview);
  const [localCoverPreview, setLocalCoverPreview] = useState(coverPreview);

  useEffect(() => {
    setLocalLogoPreview(logoPreview);
  }, [logoPreview]);

  useEffect(() => {
    setLocalCoverPreview(coverPreview);
  }, [coverPreview]);

  const handleSelect = async (event, type) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const dataUrl = await readFileAsDataUrl(file);

    if (type === "logo") {
      setLocalLogoPreview(dataUrl);
      onLogoChange?.({
        name: file.name,
        dataUrl,
      });
    } else {
      setLocalCoverPreview(dataUrl);
      onCoverChange?.({
        name: file.name,
        dataUrl,
      });
    }
  };

  return (
    <div className="new-merchant-information__upload-grid">
      <UploadTile
        inputId="new-merchant-logo-upload"
        label="Logo"
        preview={localLogoPreview || logoPreview}
        aspectClass="is-logo"
        onChange={(event) => {
          void handleSelect(event, "logo");
        }}
      />
      <UploadTile
        inputId="new-merchant-cover-upload"
        label="Cover"
        preview={localCoverPreview || coverPreview}
        aspectClass="is-cover"
        onChange={(event) => {
          void handleSelect(event, "cover");
        }}
      />
    </div>
  );
}
